
<template>
    <div id="root">
        <div class="huas-page">
            <div class="Nav"></div>
            <div class="huas-banner">
                <div class="huas-banner-wrapper">
                    <div class="huas-banner-text"></div>
                    <div class="huas-banner-img"></div>
                </div>
            </div>
            <div class="huas-container">
                <div class="huas-forehead">
                    <div class="lt">
                        <h4 class="huas-page-content-title">策略排名</h4>
                    </div>
                </div>
                <div class="huas-content">
                    <main class="huas-main">
                        <div class="huas-card dashboard">
                          <div class="condition sort">
                                <div class="condition-label">风格:</div>
                                <div class="condition-input">
                                  <div
                                      v-for="(c, index) in querytags"
                                      :class="returnTagsclassname(index)"
                                      @click="changeTagsList(index)"
                                      :key="index"
                                  >
                                      <div class="sort-indicator-title">{{ c }}</div>
                                  </div>
                                </div>
                            </div>
                            <div class="condition sort">
                                <div class="condition-label">排序:</div>
                                <div class="condition-input">
                                  <div
                                      v-for="(c, index) in querytypes"
                                      :class="returnclassname(index)"
                                      @click="changeList(index)"
                                      :key="index"
                                  >
                                      <div class="sort-indicator-title">{{ c }}</div>
                                  </div>
                                </div>
                            </div>
                            <div class="condition search">
                                <div class="condition-label">查找：</div>
                                <div class="condition-input">
                                    <span class="condition-search-input huas-input-affix-wrapper huas-input-search">
                                        <input id="search_strategies"
                                        placeholder="输入策略ID、名称、作者"
                                        class="huas-input"
                                        type="text"
                                        value=""
                                        />
                                        <span class="huas-input-suffix">
                                            <i aria-label="icon: search"
                                                tabindex="-1"
                                                class="anticon anticon-search huas-input-search-icon" >
                                                <svg
                                                viewbox="64 64 896 896"
                                                focusable="false"
                                                data-icon="search"
                                                width="1em"
                                                height="1em"
                                                fill="currentColor"
                                                aria-hidden="true"
                                                >
                                                <path
                                                    d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                                                ></path>
                                                </svg>
                                            </i>
                                        </span>
                                    </span>
                                </div>
                                <div style="margin: 2px；">
                                    <el-radio-group v-model="radioChartTable" size="default">
                                    <el-radio-button label="图" ></el-radio-button>
                                    <el-radio-button label="表"></el-radio-button>
                                    </el-radio-group>
                                </div>
                            </div>
                        </div>
                        <div class="huas-card">
                            <div v-if="radioChartTable==='图'">
                                <div style="display: flex; justify-items: center;"> 
                                    <el-row :gutter="30" type="block" justify="center" >
                                        <div v-for="(item, index) in strategiesList" :key="index" class="huas-chart-slt">
                                        <el-col :span="410">
                                            <el-card :body-style="{padding: '0px'}" class="chart-card">
                                            <router-link :to="{name:'strategydetailsview', query:{sid:item.sid,name:item.name, ben_name:item.ben_name}}" custom v-slot="{ navigate }">
                                                <button class="strategy_card" @click="navigate" role="link">
                                                <!-- UI for card-->
                                                <div class="card">
                                                    <div class="heading">
                                                        <div class="title">{{ item.name }}</div>
                                                        <div style="flex: 1px"></div>
                                                        <div class="author">{{ item.author }}</div>
                                                    </div>                  
                                                    <div class="card-image">
                                                    <strat_grid_amchart :chart_data="item.data" :ben_name="item.ben_name"></strat_grid_amchart>
                                                    </div>
                                                    <div class="details">
                                                    <div class="details_block" style="font-size: 1.2em; font-weight: 550; color: rgb(237, 65, 65); padding-top:5px">
                                                        <div style="display:flex; padding-top:10px">{{ item.stPrice }}元/月</div>
                                                    </div>
                                                    <div style="flex: 20px"></div>
                                                    <div class="details_block">
                                                        <div class="details_block_top">资金上限</div>
                                                        <div class="details_block_bottom">{{ item.fundingCap }}万</div>
                                                    </div>
                                                    <div style="flex: 1px"></div>
                                                    <div class="details_block">
                                                        <div class="details_block_top">实盘天数</div>
                                                        <div class="details_block_bottom">{{ item.realTradingDays }}天</div>
                                                    </div>
                                                    <div style="flex: 1px"></div>
                                                    <div class="details_block">
                                                        <div class="details_block_top">实盘收益</div>
                                                        <div class="details_block_bottom" style="padding-top: 3.5px">{{ item.realTradingReturns }}%</div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </button>
                                            </router-link>
                                            </el-card>
                                        </el-col>
                                        </div>
                                    </el-row>
                                </div>
                            </div>
                            <div v-else-if="radioChartTable==='表'" style="display: block; justify-content: center">
                                <div  style="display: block; justify-content: left;">
                                    <div v-for="(item, index) in strategiesList" :key="index" class="huas-table-slt">
                                        <div class="huas-card strategy-table-card huas-card-bordered huas-card-hoverable">
                                        <el-card  :body-style="{padding: '0px'}"  class="huas-card-body">
                                            <div class="StrategyItem">
                                              <div class="StrategyItem-head">
                                                  <div class="StrategyItem-head-hd">
                                                      <div class="strategy-rank" v-if="item.RowNum == 1">
                                                          <img
                                                          class="strategy-rank-tag"
                                                          src="data:image/png;base64,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"
                                                          alt=""
                                                          />
                                                      </div>
                                                      <div class="strategy-rank" v-else-if="item.RowNum == 2">
                                                          <img
                                                          class="strategy-rank-tag"
                                                          src="data:image/png;base64,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"
                                                          alt=""
                                                          />
                                                      </div>
                                                      <div class="strategy-rank" v-else-if="item.RowNum == 3">
                                                          <img
                                                          class="strategy-rank-tag"
                                                          src="data:image/png;base64,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"
                                                          alt=""
                                                          />
                                                      </div>
                                                      <div class="strategy-rank" v-else-if="item.RowNum > 3 && item.RowNum < 1000" >
                                                          <div class="strategy-rank-text" style="font-size: 15px">
                                                          {{ item.RowNum }}
                                                          </div>
                                                          <img
                                                          class="strategy-rank-tag"
                                                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAACNCAMAAABG+z4NAAAASFBMVEV8yOz////7/v/t+P2e1/Lz+v7e8fvR7PmGze/n9vz1/P7X7/qR0vDN6/mMz++k2fKv3vS84/bi8/uq3PO14PWW1PDG6PfB5veARtnZAAAB3UlEQVR42u3Tu3aDMBREUfTCQjwcJOz8/58GxYmn0FoR+MbQzK3U7Sl0GqVUc87NmVZaN+fcrL9505xzi9Oq0S4251zqMm/65py7xpD5S3PO2daRJ7/hyJMnT548efLkyZMnT548efLkyZMnT548efIbjjx58uTJkydPnjx58uTJkydPnjx58uTJkyf/6nl/PA97GobJn8T7wV5TsrfJH8kDT8t9HD8/rhhwFO8ne13ufey6dh1gB+8P4IHfvnETdHDrgBkD3skD//i8ZFwrpbXp+nFO64AjeO8Hu+KtcRnPp0MesGDAG/mMz2Pb/eIYcF/wBwV8BU/z2ANXGBAx4D389IOb8MTha2fiBRX+L4/WgJcDUKGAr7QGvBzwrFDA11r744oKhXzZWuV0wAApX7ZWPVRoJy/l8d034WWFQt4XrW3ydUCFVX5Pa/VDBBdU+BcvaE0JKgQvaO3VCsELWhNUCF7QmqBC8AWeBHilwgo/bWlNXiF4cWv1CAwqLHhBa4IKwRetVXF5heB3tiavsOT93tbkFYL3e1uTV+ifvLW3va3JK1y/2YPv55T2tiavMC1jDCvv4ngfd7YmrzCb3corbWLbHYVjQIyd05kPzgV9kI4BD7TJT9jH3UP9AojjNBgLlrJQAAAAAElFTkSuQmCC"
                                                          alt=""
                                                          />
                                                      </div>
                                                      <div class="strategy-rank" v-else>
                                                          <div class="strategy-rank-text" style="font-size: 15px">
                                                          {{ item.RowNum }}
                                                          </div>
                                                          <img
                                                          class="strategy-rank-tag"
                                                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAACNCAMAAABG+z4NAAAASFBMVEV8yOz////7/v/t+P2e1/Lz+v7e8fvR7PmGze/n9vz1/P7X7/qR0vDN6/mMz++k2fKv3vS84/bi8/uq3PO14PWW1PDG6PfB5veARtnZAAAB3UlEQVR42u3Tu3aDMBREUfTCQjwcJOz8/58GxYmn0FoR+MbQzK3U7Sl0GqVUc87NmVZaN+fcrL9505xzi9Oq0S4251zqMm/65py7xpD5S3PO2daRJ7/hyJMnT548efLkyZMnT548efLkyZMnT548efIbjjx58uTJkydPnjx58uTJkydPnjx58uTJkyf/6nl/PA97GobJn8T7wV5TsrfJH8kDT8t9HD8/rhhwFO8ne13ufey6dh1gB+8P4IHfvnETdHDrgBkD3skD//i8ZFwrpbXp+nFO64AjeO8Hu+KtcRnPp0MesGDAG/mMz2Pb/eIYcF/wBwV8BU/z2ANXGBAx4D389IOb8MTha2fiBRX+L4/WgJcDUKGAr7QGvBzwrFDA11r744oKhXzZWuV0wAApX7ZWPVRoJy/l8d034WWFQt4XrW3ydUCFVX5Pa/VDBBdU+BcvaE0JKgQvaO3VCsELWhNUCF7QmqBC8AWeBHilwgo/bWlNXiF4cWv1CAwqLHhBa4IKwRetVXF5heB3tiavsOT93tbkFYL3e1uTV+ifvLW3va3JK1y/2YPv55T2tiavMC1jDCvv4ngfd7YmrzCb3corbWLbHYVjQIyd05kPzgV9kI4BD7TJT9jH3UP9AojjNBgLlrJQAAAAAElFTkSuQmCC"
                                                          alt=""
                                                          />
                                                      </div>
                                                  </div>
                                                  <div class="StrategyItem-head-bd">
                                                      <router-link :to="{name:'strategydetailsview', query:{sid:item.sid,name:item.name, ben_name:item.ben_name}}" custom v-slot="{ navigate }">
                                                          <div class="strategy-button-card" @click="navigate" role="link">
                                                            <span class="strategy-title">{{item.name}}  </span>
                                                          </div>
                                                      </router-link>
                                                      <div class="strategy-tags">
                                                        <div v-for="(substr,idx) in item.策略特性" :key="idx">
                                                          <div class="StrategyTag strategy-tags-tag">
                                                              {{ substr }} 
                                                          </div>
                                                        </div> 
                                                      </div>
                                                  </div>
                                                  <div class="StrategyItem-head-ft">
                                                  <div class="strategy-author">
                                                      <img
                                                      class="strategy-avatar"
                                                      src="../assets/user_avatar/159632_1.jpg"
                                                      alt=""
                                                      /><span class="strategy-owner">{{ item.author }}</span>
                                                  </div>
                                                  </div>
                                              </div>
                                              <div class="StrategyItem-body">
                                                <div class="strategy-indexes">
                                                <div class="strategy-index">
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-if="item.策略累计收益率 >= 0"
                                                    style="color: rgb(231, 76, 60)"
                                                    >
                                                    {{ item.策略累计收益率 }}
                                                    </span>
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-else=""
                                                    style="color: rgb(6, 245, 6)"
                                                    >
                                                    {{ item.策略累计收益率 }}
                                                    </span>
                                                    <span class="index-name">累计收益</span>
                                                </div>
                                                <div class="strategy-index">
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-if="item.策略年化收益率 >= 0"
                                                    style="color: rgb(231, 76, 60)"
                                                    >
                                                    {{ item.策略年化收益率 }}
                                                    </span>
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-else
                                                    style="color: rgb(6, 245, 6)"
                                                    >
                                                    {{ item.策略年化收益率 }}
                                                    </span>
                                                    <span class="index-name">年化收益</span>
                                                </div>
                                                <div class="strategy-index">
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-if="item.策略当日收益率 >= 0"
                                                    style="color: rgb(231, 76, 60)"
                                                    >
                                                    {{ item.策略当日收益率 }}
                                                    </span>
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-else
                                                    style="color: rgb(6, 245, 6)"
                                                    >
                                                    {{ item.策略当日收益率 }}
                                                    </span>
                                                    <span class="index-name">今日收益</span>
                                                </div>
                                                <div class="strategy-index">
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-if="item.策略近1周收益率 >= 0"
                                                    style="color: rgb(231, 76, 60)"
                                                    >
                                                    {{ item.策略近1周收益率 }}
                                                    </span>
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-else
                                                    style="color: rgb(6, 245, 6)"
                                                    >
                                                    {{ item.策略近1周收益率 }}
                                                    </span>
                                                    <span class="index-name">本周收益</span>
                                                </div>
                                                <div class="strategy-index">
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-if="item.策略近1月收益率 >= 0"
                                                    style="color: rgb(231, 76, 60)"
                                                    >
                                                    {{ item.策略近1月收益率 }}
                                                    </span>
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-else
                                                    style="color: rgb(6, 245, 6)"
                                                    >
                                                    {{ item.策略近1月收益率 }}
                                                    </span>
                                                    <span class="index-name">本月收益</span>
                                                </div>
                                                <div class="strategy-index">
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-if="item.策略近3月收益率 >= 0"
                                                    style="color: rgb(231, 76, 60)"
                                                    >
                                                    {{ item.策略近3月收益率 }}
                                                    </span>
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-else
                                                    style="color: rgb(6, 245, 6)"
                                                    >
                                                    {{ item.策略近3月收益率 }}
                                                    </span>
                                                    <span class="index-name">本季收益</span>
                                                </div>    
                                                <div class="strategy-index">
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-if="item.策略近1年收益率 >= 0"
                                                    style="color: rgb(231, 76, 60)"
                                                    >
                                                    {{ item.策略近1年收益率 }}
                                                    </span>
                                                    <span
                                                    class="index-value FormatterNumber"
                                                    v-else
                                                    style="color: rgb(6, 245, 6)"
                                                    >
                                                    {{ item.策略近1年收益率 }}
                                                    </span>
                                                    <span class="index-name">今年收益</span>
                                                </div>                                                                                               
                                                <div class="strategy-index">
                                                    <span class="index-value FormatterNumber">
                                                    {{ item.策略最大回撤率 }}
                                                    </span>
                                                    <span class="index-name">最大回撤</span>
                                                </div>
                                                <div class="strategy-index">
                                                    <span class="index-value FormatterNumber">
                                                    {{ item.初始资金 }}
                                                    </span>
                                                    <span class="index-name">初始资金</span>
                                                </div>
                                                <div class="strategy-index">
                                                  <span class="index-value FormatterNumber">
                                                   {{ item.开始时间 }}
                                                  </span>
                                                  <span class="index-name">开始时间</span>
                                                </div>
                                              </div>
                                            </div>


                                            </div>
                                        </el-card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else="">

                            </div>
                            <div style="display:block;align-items: center;justify-content:center;">
                                <div class="huas-chart-pagination">
<!--                                     <el-pagination
                                        style="justify-content: center; padding:30px"
                                        background
                                        @current-change="handleCurrentChange"
                                        :current-page.sync="parseInt(boardInfo.pageNum)"
                                        :page-size=9
                                        layout="prev, pager, next"
                                        :page-count="parseInt(boardInfo.pages)">
                                    </el-pagination> -->
                                    <Page
                                        :total="parseInt(boardInfo.total)"
                                        :page-size=9
                                        :current="parseInt(boardInfo.pageNum)"
                                        @on-change="handleCurrentChange"
                                        size="default"
                                        show-total
                                      ></Page>
                                </div>
                            </div>
                        </div>
                    </main>
                    <aside class="huas-main-sidebar">
                          <sidebarView></sidebarView>
                    </aside>
                </div>
            </div>
        </div>
    </div>
</template>
 

  <script>
  import { toRefs,reactive, onMounted } from 'vue'
  import { useRouter} from "vue-router"
  
  import strat_grid_amchart from '@/components/strat_board_amcharts/strat_grid_amchart2.vue'
  import sidebarView from '@/views/sidebarView.vue'
  import API from "@/api/axiosInstance"
  
  export default {
      
      name: 'StrategiesView',
      components: {
        strat_grid_amchart,
        sidebarView
      },
      data() {
            return {
            data: [
                {
                策略名称: "",
                策略ID: "",
                策略特性: "",
                策略累计收益率: "",
                策略年化收益率: "",
                urlurl: "",
                },
            ],
            querytags:[
              '全部',
              '热门',
              '强势',
              '趋势',
              '反转',
              '择时',
              '小盘',
              '大盘',
              '价值',
              '成长',
              '重组',
              '次新',
              '行业',
              '创业',
              '对冲',
              '稳健',
              '科创',
              '沪深300',
              '中证500',
              'ETF',
              'ST',
              '可转债',
              'T+0'
            ],
            querytypes: [
                "综合排序",
                "累计收益",
                "年化收益",
                "胜率",
                "今日收益",
                "近1周收益",
                "近1月收益",
                "近3月收益",
                "近6月收益",
                "近1年收益",
                "最大回撤",
                "夏普比率",
                "最新发布",
            ],
            currentIndex: 0,
            currentTagsIndex: 0,
            radioChartTable: '图',
            };
        },

      setup() {
        const router = useRouter();
        // set up the variables for storing data from server
        let data = reactive([]);            // variable to store all data from server
        let boardInfo = reactive([]);       // general info for board, like pages etc.
        let strategiesList = reactive([]);  // strategies' info for demonstration
        var currentPage = "1";
        var currentSort = "1";
        let currentIndex = reactive({ index: 0 });   
        let currentTagsIndex = reactive({ index: 0 });   
        
      //从sessionStorage得到当前要显示的页数
      const getPage = () => {
        let sessionPage = sessionStorage.getItem('strategyListPage');
          if (sessionPage != null) {
            currentPage = sessionPage
          } else {
            currentPage = "1"
          }
          let sessionSort = sessionStorage.getItem('strategiesViewSort');
          if (sessionSort != null) {
            currentSort = sessionSort
          } else {
            currentSort = "1"
          }
          currentIndex.index = parseInt(currentSort);
      }
        getPage();
  
        function getData(sortNo,pageNum){
          let moment = require('moment');
          // get data from server
          API({
              url:'/ios.ashx?typedata=strategiesreview&querytype='+sortNo+'&page='+ pageNum +'&pagesize=9&benchcode=sh000300&date=2022-01-01&interval=1&webpage=strategiesview',
              method:'get'
          }).then((res)=>{
            // mapping the server data
            data.data = res.data.list策略;
            // TODO: extracting board info?
            boardInfo.pageNum = res.data.pageNum;
            boardInfo.pages = res.data.pages;
            boardInfo.total = res.data.total;
  
            // clear the strategy list
            
            if(data.data && Array.isArray(data.data)){
              strategiesList.splice(0, strategiesList.length);
              data.data.forEach(function(item) {
                // set up a variable for storing all info for a strategy
                let strategy = {
                  name: "",
                  author: "",
                  ben_name:"",
                  realTradingDays: "",
                  realTradingReturns: "",
                  stPrice: "",
                  fundingCap: "",
                  RowNum:0,
                  data: [{
                    date: "",
                    value: "",
                    bench_value: ""
                  }]
                };
    
                // mapping description of the strategy
                strategy.name = item.策略名称;
                strategy.ben_name = item.基准名称;
                strategy.author = item.策略作者;
                strategy.realTradingDays = item.实盘天数;
                strategy.realTradingReturns = item.策略累计收益率.toFixed(2);
                strategy.stPrice = item.策略定价;
                strategy.fundingCap = item.资金上限;
                strategy.RowNum = item.RowNum;
                strategy.sid = item.sid;
                strategy.策略累计收益率 = item.策略累计收益率.toFixed(2);
                strategy.策略年化收益率 = item.策略年化收益率.toFixed(2);
                strategy.策略特性 = returnStringArr(item.策略特性);
                strategy.作者描述 = item.作者描述;
                strategy.净值涨跌幅 = item.净值涨跌幅;
                strategy.策略定价 = item.策略定价;
                strategy.资金上限 = item.资金上限;
                strategy.初始资金 = item.初始资金;
                strategy.实盘分数 = item.实盘分数;
                strategy.策略当日收益率 = item.策略当日收益率.toFixed(2);
                strategy.策略近1周收益率 = item.策略近1周收益率.toFixed(2);
                strategy.策略近1月收益率 = item.策略近1月收益率.toFixed(2);
                strategy.策略近3月收益率 = item.策略近3月收益率.toFixed(2);
                strategy.策略近6月收益率 = item.策略近6月收益率.toFixed(2);
                strategy.策略近1年收益率 = item.策略近1年收益率.toFixed(2);
                strategy.策略最大回撤率 = item.策略最大回撤率.toFixed(2);
                strategy.胜率 = item.胜率;
                strategy.夏普比率 = item.夏普比率;
                var n=item.创建日期.split("T");
                strategy.开始时间 = n[0];
                
                //console.log('strategy.开始时间=',strategy.开始时间);
                // adjusting data for echart 
                // turning list of objects into three corresponding arrays
                strategy.data.length = 0;
                item.data.forEach(function(strat) {
                  strategy.data.push({
                    date:moment(strat.utc).format('YYYY/MM/DD'),//strat.utc,
                    value: Number(strat.vpct),   
                    bench_value: Number(strat.b_vpct),
                  })
                })
                
                // adding the strategy back to the list
                strategiesList.push(strategy);
              })
          }
          });
        }
  
        // 根据页码刷新列表
        function handleCurrentChange(val) {
          let sessionSort = sessionStorage.getItem('strategiesViewSort');
          if (sessionSort != null) {
            currentSort = sessionSort
          } else {
            currentSort = "1"
          }
          currentIndex.index = parseInt(currentSort);

          getData(currentSort,val);
          sessionStorage.setItem('strategiesView', val);
          sessionStorage.setItem('strategiesViewSort',currentSort);
        }

        function changeList(val){
          if(currentIndex.index == parseInt(val)){
            let sessionPage = sessionStorage.getItem('strategyListPage');
            if (sessionPage != null) {
              currentPage = sessionPage
            } else {
              currentPage = "1"
            }
            getData(val,currentPage);
          }
          else{
            currentIndex.index = parseInt(val);
            getData(val,'1');
            sessionStorage.setItem('strategiesView', '1');
            sessionStorage.setItem('strategiesViewSort', val);
          }
        }

        function changeTagsList(val){

          if(currentTagsIndex.index == parseInt(val)){
            //let sessionPage = sessionStorage.getItem('strategyListPage');
            //if (sessionPage != null) {
            //  currentPage = sessionPage
            //} else {
            //  currentPage = "1"
            //}
            //getData(val,currentPage);
          }
          else{
            currentTagsIndex.index = parseInt(val);
            //getData(val,'1');
            //sessionStorage.setItem('strategiesView', '1');
            //sessionStorage.setItem('strategiesViewSort', val);
          }

        }

        function returnclassname(index) {
            //console.log('0 index=',index, currentIndex.index);
            if (index === currentIndex.index) {
                return "sort-indicator active";
            } else {
                return "sort-indicator";
            }
        }
        function returnTagsclassname(index) {
            if (index === currentTagsIndex.index) {
                return "sort-indicator active";
            } else {
                return "sort-indicator";
            }
        }
        function returnStringArr(str){
          var str1=str.replace(/、/g,";");
          str1=str1.replace(/，/g,";");
          str1=str1.replace(/；/g,";");
          str1=str1.replace(/,/g,";");
          var arr = str1.split(";");
          return arr;
        }
  
        onMounted(() => {
          if (router.currentRoute.value.path == "/Strategies") {
            // 不清除
          } else {
            sessionStorage.removeItem('strategiesView')
            sessionStorage.removeItem('strategiesViewSort')
          }
          getPage();
          getData(currentSort,currentPage);
        });
  
        return { ...toRefs(data),boardInfo, strategiesList, currentPage,currentSort,returnclassname,returnTagsclassname, handleCurrentChange,changeList,changeTagsList};
      }
  }
  </script>
  
  <style lang="scss" scoped>

:root {
  --main-bg-color: coral;
  --main-txt-color: blue;
  --main-padding: 15px;
  --white-color: #fff;
  --huas-color-red-0: #ec2000;
  --huas-color-red-1: #e74c3c;
  --huas-color-orange-0: #ec8950;
  --huas-color-blue-0: #1890ff;
  --huas-color-blue-1: #1099ff;
  --huas-font-color-0: #555;
  --huas-font-color-1: #888;
  --huas-page-bg-color: #f7f7f7;
  --huas-border-radius: 2px;
  --huas-border-color: #f6f6f6;
  --huas-border-color-dark: #d9d9d9;
  --huas-font-size-tags: 10px;
  --huas-font-size-base: 14px;
  --huas-font-size-title: 22px;
  --huas-font-color-base: var(--huas-font-color-0);
  --huas-font-color-light: var(--huas-font-color-1);
  --huas-main-container-width: 1580px;

  --huas-menu-item-active-bg-color: #fff7f7;
  --huas-radio-border-color: var(--huas-border-color-dark);
  --huas-radio-color-checked: var(--huas-color-red-1);
  --huas-radio-color-hover: var(--huas-color-red-1);
  --huas-radio-color-active: var(--huas-color-red-1);
  --huas-radio-border-color-checked: var(--huas-color-red-1);
  --huas-radio-button-border-radius: var(--huas-border-radius);
}

*,
:after,
:before {
  box-sizing: border-box;
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

#root {
  padding-top: 25px;
  padding-bottom: 25px;
}
.huas-page {

  margin: auto;
}

.Nav {
  --white-color: #fff;
  --nav-links-height: 40px;
  --nav-links-width: 400px;
  position: relative;
  width: 100%;
  font-size: 15px;
  background-color: var(--white-color);
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 4%);
}

.huas-banner {
  height: 280px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAHCAQMAAAAjHfzJAAAABlBMVEXl7PHs8PVJg6YIAAAFbklEQVR42uzOsW0EMAwEsBgqXHoEjaLRNPplgPSPEHhOwJ9/b/LHz79HpldMB0yfb/pDSkxfMf2+6Q9pMT1iesV0wPT5pj+kxPQV009Mt5geMb1iOmD6iOkS01dMPzHdYnrE9IrpgOkjpktMXzH9xHSL6RHTC6ZPwHSJ6Sumn5huMb1iOmD6iOkS01dMt5geMb1g+gRMl5i+YrrF9IjpBdMnYLrE9BPTLaZXTAdMl5i+YrrF9IjpgOkjpq+YfmJ6xHTA9BHTV0y3mB4xHTBdYvqJ6RbTC6ZPwPQV0y2mR0wHTJeYfmJ6xHTAdInpJ6ZHTAdMl5h+YnrEdMB0ieknphdMn4DpK6ZbTC+YroDpJ6YHTJ+A6SumW0wHTJeYbjG9YLoCpp+YXjB9AqafmF4wfQKmn5heMH0Cpp+YXjBdAdMtphdMV8B0i+mA6SumB0yfgOknphdM34DpAdMnYPqJ6YDpK6YHTFfAdIPpEzD9xHTA9BXTC6YrYHrAdAVMD5iugOkG0ydgusH0CZhuMF0B0wOmK2B6wPQNmF4w/UstHVsxDAIBDH33rqBkBEa50RhdKeLYDiyANMEv1BCiEaK7EB0I0SVEJ0L0FKI7PnQgRJcQ3RCiEaKHEJ0I0VOI7vjQgRBdQnQiRE8huiNEI0QPIToQoocQnQjRJUQnQnQJ0YkQXUJ0IkSXEJ0I0SVEJ0L0EKIDfOgBPjSgQ3dAh56ADd0AbOgCkKETABl6AOBCBwC40B0AXOgJACp08k2FLr6Z0MGVCd25MqEnVyJ08kuEHvzyoIM7D7pz50EXdxp08KRBd5406MmTBZ28sqAHryxo3knQjXcSdPFOguYvB3q5w4Fe7lCgg/8U6PUOBXq9w4AOlgzoxpIBXSwZ0KwJ0I01AXqwJkCzdT66sXU+erB1PnqydTw62Tse3dk7Hv1hds6JIAqhAAgWRfBDJCAFaUifFbC8I5xW0Jd/9vTgwZ5ePNjThwd7mhd5+uNFnt68yNOXF3d68OROL57c6cOTO82bOj15U6c3b+r05c2cHgTM6Y+AOb0JmNOXgDg9iIjTi4g4fYiI04S86UnIm16EvOlDyJsmpk1PYtr0IqZNH2LaNAlrepKwphcJa/qQsKbJSNODjDT9kZGmNxlp+pJxpgcpZ/oj5UxvUs70IeVMk1OmJzllepFTpg85ZfqSM6YHBWP6o2BMbwrG9KFgTFMRpicVYfqjIkxvKsL0pSJMU/KlJyVfelHypTclX/pS0qUHNV16UtOlFzVdelPTpS81XZoGW3rSYEsvGmzpTYMtfWmwpemQpScdsvRHhyy96ZClDx2yNC2u9KDFlf5ocaUXLa70psWVvrS40j9m55gIgBAIgmBRBBe+BKQgDenzFnazaQVNRpXeZFTpIaNKHzKq9CWjSj8ypvQiZEpvQqb0EDKlDyFT+hIypUmJ0ouUKL1JidJDSpQ+pETpS0qUfqQ86UXMk97EPOkh5kkfYp70JeZJP2KeNDlNepHTpIecJv2R06QPOU36ktOkKVjSi4IlvSlY0kPBkv4oWNKHgiX9KFjSNCTpRUOS3jQk6aEhSX80JOlDQ5J+NCRpKo70ouJIbyqO9FBxpD8qjvSh4khfKo70o+JI01GkFx1FetNRpIeOIv3RUaT/cuvYCGAghmHY/lMjM3wV8ewJVBF+Ld7E6NfiTYz2eAujfy+eYvEUi6dYPMHHlGKmz4z+3RZFWxRtUbRF0RZFWxRtUcy0YqYVM62YacVMK2b6yOgBWxRtUbRF0RZFWxRtUbTlxugFWxRtUbRF0RZFW26MtnBFEBVtUbTlxOgJEBVBVATxxOgJEBVBVATxwugNxRVBVATxwugNxX0hnhjuqX6i6AAAAABJRU5ErkJggg==);
  background-size: 100%;
  background-repeat: no-repeat;
}

.huas-banner-wrapper {
  width: var(--huas-main-container-width);
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 100%;
}

.huas-banner .huas-banner-text {
  display: inline-block;
  margin-left: 76px;
  width: 280px;
  height: 104px;
  background: url(../assets/banner-image-strategy01.png);
  background-size: 100%;
  background-repeat: no-repeat;
}

.huas-banner .huas-banner-img {
  display: inline-block;
  margin-right: 38px;
  height: 280px;
  width: 564px;
  background: url(../assets/l131nDb9qb.png);
  background-size: 100%;
  background-repeat: no-repeat;
}

.huas-container {
  overflow: visible;
  width: var(--huas-main-container-width);
  margin: 0 auto;
  display: block;
  align-items: center;
  justify-content:center;
}

.huas-card-body{
    width: 100%;
    display: flex;
}
.StrategyItem {
  padding-top: 16px;
  width: 1270px;
  position: relative;
}
.StrategyItem-head {
  margin-left: 0px;
  display:flexbox;
}
.StrategyItem .strategy-rank {
  position: relative;
  margin-left: 10px;
}
.StrategyItem .strategy-rank-text {
  color: #fff;
  font-size: 18px;
  line-height: 28px;
  font-weight: bolder;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
}
.StrategyItem-head .StrategyItem-head-hd {
  flex-grow: 1;
  margin-left: 18px;
}

.StrategyItem-head-ft {
  display: flex;
  align-items: flex-start;
}
.StrategyItem .strategy-author {
  display: flex;
  width: 10em;
  align-items: center;
}
.StrategyItem .strategy-avatar {
  height: 24px;
  width: 24px;
  border-radius: 50%;
}

.StrategyItem .strategy-owner {
  margin-left: 3px;
  color: #777;
}
.StrategyItem-body {
  margin-top: 18px;
  padding-right: 20px;
}

.StrategyItem .strategy-indexes {
  display: flex;
}

.StrategyItem .strategy-index {
  flex: 1 1;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  flex-direction: column;
  flex-wrap: nowrap;
  
}
.StrategyItem .strategy-index .index-value {
  color: var(--huas-font-color-base);
  font-size: 18px;
  line-height: 38px;
}
.StrategyItem .strategy-index .index-name {
  color: #999;
  line-height: 20px;
}
.StrategyItem-head-bd{
  position: relative;
  align-items:center;
}

.huas-input-affix-wrapper .huas-input:not(:last-child) {
  padding-right: 10px;
}

.condition-search-input .huas-input {
  border-radius: 16px;
}
.huas-input-affix-wrapper .huas-input {
  min-height: 100%;
}
.huas-input-affix-wrapper .huas-input {
  position: relative;
  text-align: left;

}
.huas-input {
  --huas-input-border-color: #eee;
  --huas-input-border-color-active: #a5a5a5;
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  -webkit-font-feature-settings: "tnum";
  font-feature-settings: "tnum", "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid var(--huas-input-border-color);
  border-radius: 4px;
  transition: all 0.3s;
}
.huas-input-affix-wrapper .huas-input-suffix {
  right: 12px;
}

.huas-input-affix-wrapper .huas-input-prefix,
.huas-input-affix-wrapper .huas-input-suffix {
  position: absolute;
  top: 50%;
  z-index: 2;
  color: rgba(0, 0, 0, 0.65);
  line-height: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.strategy-list-wrapper {
  padding: 10px 0 50px;
  margin-top: 20px;
  min-height: 200px;
}

article,
aside,
blockquote,
body,
button,
code,
dd,
details,
div,
dl,
dt,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
hr,
input,
legend,
li,
menu,
nav,
ol,
p,
pre,
section,
td,
textarea,
th,
ul {
  margin: 0;
  padding: 0;
}

article,
aside,
blockquote,
body,
button,
dd,
details,
div,
dl,
dt,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
hr,
input,
legend,
li,
menu,
nav,
ol,
p,
section,
td,
textarea,
th,
ul {
  margin: 0;
  padding: 0;
}

article,
aside,
footer,
header,
nav,
section {
  display: block;
}

aside {
  display: block;
}
.huas-forehead, .huas-forehead .lt {
  display: flex;
  align-items:center;
  
}

.huas-forehead {
  width: var(--huas-main-container-width);
  justify-content: space-between;
  padding-left: 18px;
  padding-top: 32px;
  padding-bottom: 12px;
}


.huas-content {
  display: flex;
  justify-content: space-between;
}
.more-tips {
  text-align: center;
  line-height: 2;
  color: #8a8a8a;
  width: 45.2em;
  margin: 50px auto 60px;
}

.huas-page-content-title {
  font-weight: 600;
  font-size: 24px;
  color: #333;
  margin: 0 15px 0 0;
}
.huas-main {
  width: 1270px;
}

.huas-main-sidebar{
  margin-left: 10px;
  width: 310px;
}
.anticon-search{
    width: 500px;
}
.StrategyItem {
  position: relative;
}
.StrategyItem-head {
  margin-left: 10px;
  display: flex;
}

.StrategyItem .strategy-rank {
  position: relative;
}

.StrategyItem .strategy-rank-tag {
  width: 36px;
}

.StrategyItem .strategy-name {
  font-size: 20px;
  color: #151515;
  font-weight: 500;
  max-width: 532px;
  display: inline-block;
  text-decoration: none;
}

.StrategyTag {
  display: flex;
  font-size: var(--huas-font-size-tags);
  color: #4a90e2;
  border: 1px solid #8eb9ed;
  background-color: #f6f9fd;
  border-radius: 2px;
  padding: 2px 4px;
  font-weight: 400;
}
.strategy-title{
  display: flex;
  width: 45em;
  text-align: left;
  font-size: 22px;
  color: #181515;
}

.strategy-tags{
    margin: 0;
    display: flex;
}
.strategy-tags-tag{
  margin-left: 6px;
  align-items:center;
  font-size: var(--huas-font-size-tags);
  font-weight: 400;
  
}

a {
  background-color: transparent;
}
a {
  color: #eb4239;
  background: transparent;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color 0.2s ease;
}
a {
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}

*,
:after,
:before {
  box-sizing: border-box;
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

用户代理样式表 a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}
.huas-input-search{
    width: 500px;
}
.huas-input-search-icon {
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: all 0.3s;
}

.huas-card {
  --huas-card-broder-color: var(--huas-border-color);
  --huas-card-broder-radius: 0;
  --huas-card-bg-color: #fff;
}

.huas-card,
.huas-card * {
  box-sizing: border-box;
 
}

.huas-card {
  padding: 0;
  margin: 0;
  margin-top: 20px;
  transition: all 0.3s ease-in-out;
  border-radius: var(--huas-card-broder-radius);
  background: var(--huas-card-bg-color);
}

.huas-chart-slt{
    display:flex;
    float: left;
    width: 428px;
}
.huas-table-slt{
    display:flex;
    float: left;
    width: 1270px;
}
.strategy-table-card{
    display: flex;
    width: 1270px;
    height: 170px;
    border: 0px;
    background-color: transparent;
}
.strategy-button-card{
margin: 0px;
}

.huas-chart-pagination{
    display: block; 
    float:left;
    align-items:center;
    justify-items: center;
    padding-top: 2em;
    width:1200px;
}
.huas-ranking-card{
  color: var(--huas-font-color-base);
  position: relative;

}

.huas-card-bordered {
  border: 1px solid var(--huas-card-broder-color);
    border-radius: 2px;
}

.huas-card-hoverable:hover {
  box-shadow: 0 2px 10px 0 rgba(199, 199, 199, 0.15);
}

.huas-card-head {
  min-height: 48px;
  padding-left: 16px;
  padding-right: 16px;
  zoom: 1;
  border-bottom: 1px solid var(--huas-card-broder-color);
}

.ant-card-head {
  margin-bottom: -1px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  background: transparent;
  border-bottom: 1px solid #e8e8e8;
  border-radius: var(--huas-card-broder-radius) var(--huas-card-broder-radius) 0 0;
  zoom: 1;
}

.huas-card-head-title {
  display: inline-block;
  flex: 1;
  padding: 12px 0;
  line-height: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.huas-card-head-wrapper {
  display: flex;
  align-items: center;
  /* margin: 16px 0 10px; */
}

.huas-card-head-title {
  font-weight: 500;
  font-size: 16px;
  color: #333;
}
.huas-spin-nested-loading {
  position: relative;
}
.huas-spin-container {
  position: relative;
  transition: opacity 0.3s;
}
.strategy-list {
  overflow: hidden;
}

figcaption,
figure,
main {
  display: block;
}

div {
  display: block;
}
body {
  background: var(--huas-page-bg-color);
  font-size: var(--huas-font-size-base);
  font-family: -apple-system, BlinkMacSystemFont, arial, PingFang SC, Microsoft YaHei,
    Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei,
    "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #515a6e;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.huas-container {
    overflow: visible;
    width: var(--huas-main-container-width);
    margin: 0 auto;
}
.condition .sort {
    
    border-bottom: 1px dashed #e9e9e9;
}

.condition {
    display: flex;
}
.condition.search {
    margin-top: 16px;
    padding-bottom: 16px;
    widows: 500px;
}
.condition.sort .condition-label {
    padding-top: 32px;
    line-height: 22px;
}

.condition-label {
    width: 66px;
    flex-shrink: 0;
}

.condition.sort .condition-input {
    padding-top: 32px;
    padding-bottom: 12px;
    display: flex;
    flex-flow: row wrap;
}

.condition-input {
    flex-grow: 1;
}

.sort-indicator.active, .sort-indicator:hover {
    background: #e74c3c;
}

.sort-indicator {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 2px;
    padding: 4px 7px;
    margin-bottom: 16px;
    margin-right: 24px;
}

.sort-indicator.active .huas-icon-info, .sort-indicator.active .sort-indicator-title, .sort-indicator:hover .huas-icon-info, .sort-indicator:hover .sort-indicator-title {
    color: #fff;
}

.sort-indicator-title {
    color: var(--huas-font-color-base);
}


  .chart-card {
    margin-bottom: 30px; 
    display: flex; 
    justify-content: center; 
    align-content: center; 
    border-radius: 8px;
  }
  
  .strategy_card {
    width: 410px;
    height: 380px;
    border: 0px;
    background-color: transparent;
  }
  
  .card {
    width: 410px;
    height: 380px;
    background-color: white;
    padding: 0em;
    border-radius: 8px;
  }
  
  .card-image {
    background-color: white;
    width: 100%;
    height: 70%;
    border-radius: 6px 6px 6px 6px;
    display: flex;
    justify-content: center;
  }
  
  .chart-card:hover {
    transform: scale(0.98) translateY(-5px);
  }
  .huas-card-body:hover {
    transform: scale(0.98) translateY(-5px);
  }
  .heading {
    height: 50px;
    line-height: 50px;
    display: flex;
  }
  
  .heading:hover {
    cursor: pointer;
  }
  
  .title {
    font-size: 18px;
    font-weight: 550;
    color: rgb(63, 121, 230);
    padding-left: 15px;
    display: flex;
    text-align: center;
  }
  
  .author {
    color: rgb(88, 88, 88);
    font-weight: 520;
    font-size: 14px;
    padding-right: 20px;
    display: flex;
    text-align: center;
  }
  
  .author:hover {
    cursor: pointer;
  }
  
  .details {
    height: 100px;
    padding: 0px 20px 0;  
    display: flex;
  }
  
  .details_block {
    color: rgb(88, 88, 88);
    font-size: 1em;
    display: block;
  }
  
  .details_block_top {
    display:flex; 
    justify-content: right; 
    padding-top: 10px;
    padding-bottom: 1px;
  }
  
  .details_block_bottom {
    display:flex; 
    justify-content: right; 
    padding-top: 1px;
  }
  
#strategy-cnt #sort-cnt span.mode {
    float: right;
    cursor: pointer;
    margin-top: -3px;
    width: 33px;
    height: 30px;
    background: url(../assets/switch-pic-list.png) no-repeat
}

#strategy-cnt #sort-cnt span.mode.list.selected {
    background: url(../assets/switch-pic-list.png) -91px 0 no-repeat
}

#strategy-cnt #sort-cnt span.mode.pic {
    background: url(../assets/switch-pic-list.png) -124px 0 no-repeat
}

#strategy-cnt #sort-cnt span.mode.pic.selected {
    background: url(../assets/switch-pic-list.png) -33px 0 no-repeat
}

  .el-pagination.is-background .el-pager li{
    background-color: white;
  }
  </style>